/**
 * Formatuje datę do 'YYYY-MM-DD' na podstawie LOKALNYCH pól kalendarza (nie UTC).
 *
 * Dlaczego NIE `date.toISOString().split('T')[0]`:
 * `toISOString()` konwertuje do UTC, więc data z kalendarza (react-day-picker
 * zwraca lokalną północ, np. `2026-06-26T00:00:00+02:00`) cofa się o jeden dzień
 * w strefach ze wschodnim offsetem od UTC (cała PL). Efekt: user wybiera 26.06,
 * a backend dostaje `since=2026-06-25` → dashboard pokazuje dane o dzień za wcześnie.
 *
 * `toLocalYmd(new Date(2026, 5, 26))` zwraca zawsze `'2026-06-26'` niezależnie od
 * strefy czasowej — bo czyta te same lokalne pola, z których datę zbudowano.
 *
 * Kontekst: VP-210.
 */
export function toLocalYmd(date: Date): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
